import {
  VideoFooterMenuOption,
  VideoFooterMenuOptionChild,
  VideoMenuItemKey,
  EVideoMenuItem,
} from 'shared/types/video.interface';

export const getVideoFooterMenuOption = (
  label: string,
  key?: VideoMenuItemKey,
  children?: VideoFooterMenuOptionChild[],
  activeOption?: string,
  type?: EVideoMenuItem.group,
  isActive?: boolean,
): VideoFooterMenuOption => ({
  label,
  key,
  children,
  activeOption,
  type,
  isActive,
});
